export const formatForUpload = (user: LocalUser) => {
  const {
    channels,
    tasks,
    last_seen,
    created_at,
    updated_at,
    deleted_at,
    type,
    online_status,
    media,
    email,
    phone,
    // @ts-ignore
    teams,
    // @ts-ignore
    meta,
    owner_id,
    owner_team_id,
    created_by,
    restricted,
    ...rest
  } = user

  // Fix values to be null instead of empty string
  const toReturn: UserUpdate & { id: string } = Object.entries(rest).reduce(
    (prev, [key, val]) => {
      if (
        (typeof val === 'string' && val.length > 0) ||
        typeof val !== 'string'
      ) {
        prev[key] = val
      } else {
        prev[key] = null
      }
      return prev
    },
    {} as UserUpdate & { id: string }
  )

  return toReturn
}
